"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _Nugget2 = _interopRequireDefault(require("../Nugget"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var VideoPlaylistNugget = /*#__PURE__*/function (_Nugget) {
  (0, _inherits2["default"])(VideoPlaylistNugget, _Nugget);

  var _super = _createSuper(VideoPlaylistNugget);

  function VideoPlaylistNugget(json) {
    var _this;

    (0, _classCallCheck2["default"])(this, VideoPlaylistNugget);
    _this = _super.call(this, json);
    console.log('VIDEOPLAYLISTNUGGET', json);
    _this.videos = json.videos;
    _this.show_title = json.show_title;
    _this.title = json.title;
    _this.info = json.info;
    return _this;
  }

  return VideoPlaylistNugget;
}(_Nugget2["default"]);

VideoPlaylistNugget.CLASS = 'videoplaylist';
var _default = VideoPlaylistNugget;
exports["default"] = _default;